import {
  SET_VEHICLE_TYPE_ID,
  SET_VEHICLE_TYPE_DROPDOWN,
  SET_CATALOG_ITEM_DETAILS,
  SHOW_REQUEST_REASON,
  SHOW_ADD_REQUEST_REASON,
  GET_BRANCH_DETAILS,
  GET_ITEM_DETAILS,
  GET_VEHICLE_DETAILS,
  SET_VALID_ASSET_DATA_PLANNED,
  SET_ASSET_VALIDATION_PLANNED_FLG,
  SET_AUTO_COMPLETE_ASSET_PLANNED,
  SET_SELECTED_BRANCH_DETAILS,
  SET_SELECTED_VEHICLE_TYPE,
  SET_ORDER,
  GET_PREFERRED_MODEL_DROPDOWN,
  SET_PREFERRED_MODEL_DROPDOWN,
  SET_REASON_TYPES,
  SET_ITEM_DETAILS_GROWTH,
  SET_REASON_INFO,
  SET_ADD_CLICK_FLG,
  SHOW_CATALOG_ITEM_DETAILS,
  SET_SELECTED_VEHICLES_COUNT,
  SET_ADD_ORDER,
  SET_FILTERED_CATALOG_ITEM_VALUES,
  SET_CREATE_ORDER_COMPLETE_FLAG,
  SET_UPLOADED_BLOB_URL_LIST,
  SET_UPLOAD_FILES_COMPLETE,
  SET_ASSET_TYPES,
  SET_SPLICE_FLAG,
  SET_EQUIPMENT_DROPDOWN,
  SET_SEATINGCAPACITY_DROPDOWN,
  SET_UTILITYMANUFACTURE_DROPDOWN,
  SET_UTILITYCAPACITY_DROPDOWN,
  SET_TRAILERMANUFACTURE_DROPDOWN,
  SET_TRAILERSTYLE_DROPDOWN,
  SET_TRAILERLENGTH_DROPDOWN,
  SET_TRAILERFUELTANK_DROPDOWN,
  SET_TRAILERCHARGINGSTATION_DROPDOWN,
  SET_SNOWMANUFACTURE_DROPDOWN,
  SET_SNOWCATEGORY_DROPDOWN,
  SET_SNOWSIZE_DROPDOWN,
  SET_SNOWTYPE_DROPDOWN,
  SET_DEVELOPMENTCATEGORY_DROPDOWN,
  SET_DEVELOPMENTMANUFACTURE_DROPDOWN,
  SET_TREEMANUFACTURE_DROPDOWN,
  SET_TREEEQUIPMENTTYPE_DROPDOWN,
  SET_TREEHORSEPOWER_DROPDOWN,
  SET_TREEFUELTYPE_DROPDOWN,
  SET_STANDARDMANUFACTURE_DROPDOWN,
  SET_STANDARDCATEGORY_DROPDOWN,
  SET_UTILITYENCLOSEDCAB_DROPDOWN,
  SET_VEHICLETYPE_FLAG,
  SET_VEHICLE_HISTORY_CARD_FLAG,
  SET_SELECT_FLAG,
  SET_UPLOADED_ATTACHMENT_DETAILS,
  SET_STATE_AVAILABILITY,
  SET_PROGRAM_STATUS,
  SET_ANNUAL_HOURS,
  SET_AUTONOMOUS,
  SET_DECK_SIZES,
  SET_DECK_TYPE,
  SET_MANUFACTURER_DROPDOWN,
  SET_CATEGORY_DROPDOWN,
  SET_EDIT_CLICK_FLG,
  SET_EDIT_VEHICLE_INDEX,
  SET_SEARCH_ERROR,
  SET_ASSET_TYPE_ID,
  SET_ASSET_TYPE_TEXT,
  SET_NEXT_FLAG,
  SET_EDIT_REASON_VALUE,
  SET_CART_NAV,
  SET_HEADER_NAV,
  SET_IS_SAVE,
  SET_ORDER_ID,
  SET_ACTIVE_HEADER,
  SET_CLICK_PREVIOUS,
  SET_GRAND_TOTAL,
  SET_REASONCONDITION_DROPDOWN,
  SET_REASONSTATUS_DROPDOWN,
  SET_DROPDOWNS_BY_SUBTYPE,
  APPEND_DROPDOWN_DATA,
  SET_BRANCH_CHANGE_FLAG,
  SET_ADD_REASON_FLAG,
  SET_CATALOG_ACTIVE_STEPPER_FLAG,
  SUCCESS_COST_CENTER,
  SET_SELECTED_REASON_TYPE,
  SET_IS_REFRESH_REASON
} from "./types";

const initialState = {
  RequestReason: false,
  AddRequestReason: false,
  BranchDetails: {
    name: "",
    companyName: "",
  },
  ItemDetails: [],
  VehicleDetails: [
    {
      newEmployee: "",
      jobOrEmpId: "",
      jobOrEmpName: "",
      salesAmount: "",
      isNewEmployee: false
    },
  ],
  catalogDetails: [],
  catalogDetailsFleetRequestDetailId: null,
  setVehicleTypeId: null,
  reasonTypes: {},
  preferredMakes: {},
  setItemDetailsGrowth: {},
  orderDetails: {
    vehicleType: "",
    subOrderTypeId: 0,
    branchId: 0,
    attachmentFileObjList: {},
    attachmentUrlList: {},
    userEmailId: "",
    requests: [],
    grandTotal: 0,
    savedBy: "",
    directoryName: "",
    orderAction: "",
    orderSearchValues: [],
  },
  VehicleType: [],
  NoOfDoors: [],
  ShowCatalog: false,
  SelectedVehiclesCount: 0,
  AssetTypes: {},
  isSpliceFlag: false,
  isRefreshReason: false,
  isCatalogActiveStepper: false,
  isVehicleTypeFlag: false,
  setVehicleHistoryCardFlag: false,
  noRecordsMessage: "",
  isSelectFlag: false,
  isBranchChangeFlag: false,
  stateAvailabilityDropDown: {},
  programStatusDropDown: {},
  annualHoursDropDown: {},
  deckSizeDropDown: {},
  deckTypeDropDown: {},
  autonomousDropDown: {},
  manufacturerDropDown: {},
  categoryDropDown: {},
  editVehicleIndex: 0,
  isSearchError: false,
  assetTypeId: 0,
  assetTypeText: "",
  isNextFlag: false,
  editClickFlg: false,
  editReasonValues: {},
  setCartNav: "",
  isHeaderNav: false,
  isSaved: "",
  orderId: 0,
  setActiveHeader: "",
  setClickPrevious: false,
  grandTotal: 0,
  dropdownData: [],
  addReasonFlag: false,
  costCentersForGrid: [],
  regionsForGrid: [],
  selectedReasonType: ""
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_REQUEST_REASON:
      return {
        ...state,
        RequestReason: action.payload,
      };
    case SHOW_ADD_REQUEST_REASON:
      return {
        ...state,
        AddRequestReason: action.payload,
      };
    case GET_BRANCH_DETAILS:
      return {
        ...state,
        BranchDetails: action.payload,
      };
    case GET_ITEM_DETAILS:
      return {
        ...state,
        ItemDetails: action.payload,
      };
    case GET_VEHICLE_DETAILS:
      return {
        ...state,
        VehicleDetails: action.payload,
      };
    case SET_VALID_ASSET_DATA_PLANNED:
      return {
        ...state,
        validAssetDetailsPlanned: action.validAssetDetailsPlanned,
      };
    case SET_ASSET_VALIDATION_PLANNED_FLG:
      return {
        ...state,
        assetValidationPlannedFlag: action.assetValidationPlannedFlag,
      };
    case SET_AUTO_COMPLETE_ASSET_PLANNED:
      return {
        ...state,
        autoCompleteAssetPlanned: action.autoCompleteAssetPlanned,
      };
    case SET_CATALOG_ITEM_DETAILS:
      const catalogDetails = action.catalogDetails;
      const noRecordsMessage = action.noRecordsMessage;
      const catalogDetailsFleetRequestDetailId = action.fleetRequestDetailId ?? null;
      return {
        ...state,
        catalogDetails,
        noRecordsMessage,
        catalogDetailsFleetRequestDetailId,
      };
    case SET_VEHICLE_TYPE_DROPDOWN:
      return {
        ...state,
        VehicleTypeDropdown: action.payload,
      };

    case SET_VEHICLE_TYPE_ID:
      return {
        ...state,
        setVehicleTypeId: action.payload,
      };
    case SET_SELECTED_BRANCH_DETAILS:
      return {
        ...state,
        selectedBranchDetails: action.selectedBranchDetails,
      };
    case SET_SELECTED_VEHICLE_TYPE:
      return {
        ...state,
        selectedVehicleType: action.selectedVehicleType,
      };
    case SET_ORDER:
      return {
        ...state,
        orderDetails: action.orderDetails,
      };
    case GET_PREFERRED_MODEL_DROPDOWN:
      return {
        ...state,
        PreferredModelDropdown: action.assertMakeId,
      };
    case SET_PREFERRED_MODEL_DROPDOWN:
      return {
        ...state,
        PreferredModelDropdownList: action.payload,
      };
    case SET_REASON_TYPES:
      return {
        ...state,
        reasonTypes: action.value,
      };
    case SET_ITEM_DETAILS_GROWTH:
      return {
        ...state,
        setItemDetailsGrowth: action.value,
      };
    case SET_REASON_INFO:
      return {
        ...state,
        reasonInfo: action.reasonInfo,
      };
    case SET_ADD_CLICK_FLG:
      return {
        ...state,
        addClickFlg: action.addClickFlg,
      };
    case SHOW_CATALOG_ITEM_DETAILS:
      return {
        ...state,
        ShowCatalog: action.payload,
      };
    case SET_SELECTED_VEHICLES_COUNT:
      return {
        ...state,
        SelectedVehiclesCount: action.payload,
      };
    case SET_ADD_ORDER:
      return {
        ...state,
        OrderResponse: action.payload,
      };
    case SET_FILTERED_CATALOG_ITEM_VALUES:
      return {
        ...state,
        filteredCatalogItemValues: action.filteredCatalogItemValues,
      };
    case SET_CREATE_ORDER_COMPLETE_FLAG:
      return {
        ...state,
        isCreateOrderComplete: action.isCreateOrderComplete,
      };
    case SET_UPLOADED_BLOB_URL_LIST:
      return {
        ...state,
        BlobUrlListObj: action.BlobUrlListObj,
      };
    case SET_UPLOAD_FILES_COMPLETE:
      return {
        ...state,
        isUploadComplete: action.isUploadComplete,
      };
    case SET_ASSET_TYPES:
      return {
        ...state,
        AssetTypes: action.payload,
      };
    case SET_SPLICE_FLAG:
      return {
        ...state,
        isSpliceFlag: action.payload,
      };
      case SET_IS_REFRESH_REASON:
      return {
        ...state,
        isRefreshReason: action.payload,
      };
      case SET_CATALOG_ACTIVE_STEPPER_FLAG:
      return {
        ...state,
        isCatalogActiveStepper: action.payload,
      };
    case SET_EQUIPMENT_DROPDOWN:
      return {
        ...state,
        equipmentDropDown: action.payload,
      };
    case SET_SEATINGCAPACITY_DROPDOWN:
      return {
        ...state,
        seatingCapacityDropDown: action.seatingCapacityDropDown,
      };
    case SET_UTILITYMANUFACTURE_DROPDOWN:
      return {
        ...state,
        utilityManufactureDropDown: action.payload,
      };
    case SET_UTILITYENCLOSEDCAB_DROPDOWN:
      return {
        ...state,
        UtilityEnclosedcabDropDown: action.UtilityEnclosedcabDropDown,
      };
    case SET_UTILITYCAPACITY_DROPDOWN:
      return {
        ...state,
        utilityCapacityDropDown: action.utilityCapacityDropDown,
      };
    case SET_TRAILERMANUFACTURE_DROPDOWN:
      return {
        ...state,
        trailermanufactureDropDown: action.payload,
      };
    case SET_TRAILERSTYLE_DROPDOWN:
      return {
        ...state,
        trailerStyleDropDown: action.trailerStyleDropDown,
      };
    case SET_TRAILERLENGTH_DROPDOWN:
      return {
        ...state,
        trailerLengthDropDown: action.trailerLengthDropDown,
      };
    case SET_TRAILERFUELTANK_DROPDOWN:
      return {
        ...state,
        trailerFuelTankDropDown: action.trailerFuelTankDropDown,
      };
    case SET_TRAILERCHARGINGSTATION_DROPDOWN:
      return {
        ...state,
        trailerChargingStationDropDown: action.trailerChargingStationDropDown,
      };
    case SET_SNOWMANUFACTURE_DROPDOWN:
      return {
        ...state,
        snowManufactureDropDown: action.payload,
      };
    case SET_SNOWCATEGORY_DROPDOWN:
      return {
        ...state,
        snowCategoryDropDown: action.payload,
      };
    case SET_SNOWSIZE_DROPDOWN:
      return {
        ...state,
        snowSizeDropDown: action.snowSizeDropDown,
      };
    case SET_SNOWTYPE_DROPDOWN:
      return {
        ...state,
        snowTypeDropDown: action.snowTypeDropDown,
      };
    case SET_DEVELOPMENTCATEGORY_DROPDOWN:
      return {
        ...state,
        developmentCategoryDropDown: action.payload,
      };
    case SET_DEVELOPMENTMANUFACTURE_DROPDOWN:
      return {
        ...state,
        developmentManufactureDropDown: action.payload,
      };
    case SET_TREEMANUFACTURE_DROPDOWN:
      return {
        ...state,
        TreeManufactureDropDown: action.payload,
      };
    case SET_TREEEQUIPMENTTYPE_DROPDOWN:
      return {
        ...state,
        TreeEquipmentDropDown: action.TreeEquipmentDropDown,
      };
    case SET_TREEHORSEPOWER_DROPDOWN:
      return {
        ...state,
        TreeHorsePowerDropDown: action.TreeHorsePowerDropDown,
      };
    case SET_TREEFUELTYPE_DROPDOWN:
      return {
        ...state,
        TreeFuelTypeDropDown: action.TreeFuelTypeDropDown,
      };
    case SET_STANDARDMANUFACTURE_DROPDOWN:
      return {
        ...state,
        standardManufactureDropdown: action.payload,
      };
    case SET_STANDARDCATEGORY_DROPDOWN:
      return {
        ...state,
        standardcategoryDropdown: action.payload,
      };
    case SET_VEHICLETYPE_FLAG:
      return {
        ...state,
        isVehicleTypeFlag: action.payload,
      };
    case SET_SELECT_FLAG:
      return {
        ...state,
        isSelectFlag: action.payload,
      };
    case SET_UPLOADED_ATTACHMENT_DETAILS:
      return {
        ...state,
        uploadedAttachmentDetails: action.uploadedAttachmentDetails,
      };
    case SET_VEHICLE_HISTORY_CARD_FLAG:
      return {
        ...state,
        setVehicleHistoryCardFlag: action.payload,
      };
    case SET_STATE_AVAILABILITY:
      return {
        ...state,
        stateAvailabilityDropDown: action.value,
      };
    case SET_PROGRAM_STATUS:
      return {
        ...state,
        programStatusDropDown: action.value,
      };
    case SET_ANNUAL_HOURS:
      return {
        ...state,
        annualHoursDropDown: action.value,
      };
    case SET_DECK_SIZES:
      return {
        ...state,
        deckSizeDropDown: action.value,
      };
    case SET_DECK_TYPE:
      return {
        ...state,
        deckTypeDropDown: action.value,
      };
    case SET_AUTONOMOUS:
      return {
        ...state,
        autonomousDropDown: action.value,
      };
    case SET_MANUFACTURER_DROPDOWN:
      return {
        ...state,
        manufacturerDropDown: action.payload,
      };
    case SET_CATEGORY_DROPDOWN:
      return {
        ...state,
        categoryDropDown: action.payload,
      };
    case SET_EDIT_CLICK_FLG:
      return {
        ...state,
        editClickFlg: action.editClickFlg,
      };
    case SET_EDIT_VEHICLE_INDEX:
      return {
        ...state,
        editVehicleIndex: action.editVehicleIndex,
      };
    case SET_SEARCH_ERROR:
      return {
        ...state,
        isSearchError: action.payload,
      };
    case SET_ASSET_TYPE_ID:
      return {
        ...state,
        assetTypeId: action.payload,
      };
    case SET_ASSET_TYPE_TEXT:
      return {
        ...state,
        assetTypeText: action.payload,
      };
    case SET_NEXT_FLAG:
      return {
        ...state,
        isNextFlag: action.payload,
      };
    case SET_EDIT_REASON_VALUE:
      return {
        ...state,
        editReasonValues: action.editReasonValues,
      };
    case SET_CART_NAV:
      return {
        ...state,
        setCartNav: action.payload,
      };
    case SET_HEADER_NAV:
      return {
        ...state,
        isHeaderNav: action.payload,
      };
    case SET_IS_SAVE:
      return {
        ...state,
        isSaved: action.payload,
      };
    case SET_ORDER_ID:
      return {
        ...state,
        orderId: action.payload,
      };
    case SET_ACTIVE_HEADER:
      return {
        ...state,
        setActiveHeader: action.payload,
      };
    case SET_CLICK_PREVIOUS:
      return {
        ...state,
        setClickPrevious: action.payload,
      };
    case SET_GRAND_TOTAL:
      return {
        ...state,
        grandTotal: action.payload,
      };
    case SET_REASONSTATUS_DROPDOWN:
      return {
        ...state,
        StatusDropdownList: action.statusvalue,
      };
    case SET_REASONCONDITION_DROPDOWN:
      return {
        ...state,
        ConditionDropdownList: action.conditionValue,
      };
    case SET_DROPDOWNS_BY_SUBTYPE:
      return {
        ...state,
        dropdownData: action.payload,
      };
    case APPEND_DROPDOWN_DATA:
      return {
        ...state,
        dropdownData: [
          ...state.dropdownData.filter(
            (x: any) => x.dropdownName !== action.payload.dropdownName
          ),
          action.payload,
        ],
      };
    case SET_BRANCH_CHANGE_FLAG:
      return {
        ...state,
        isBranchChangeFlag: action.payload,
      };
    case SET_ADD_REASON_FLAG:
      return {
        ...state,
        addReasonFlag: action.payload,
      };
    case SUCCESS_COST_CENTER:
      return {
        ...state,
        costCentersForGrid: action.payload,
      };
      case SET_SELECTED_REASON_TYPE:
      return {
        ...state,
        selectedReasonType: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
